/**
 * Application configuration module.
 * Reads configuration from environment variables with sensible defaults.
 *
 * @module config
 */

interface AppConfig {
  /** Application display name */
  appName: string;
  /** Application version */
  appVersion: string;
  /** Whether the app is running in development mode */
  isDevelopment: boolean;
  /** Whether the app is running in production mode */
  isProduction: boolean;
  /** Azure AD SPA app registration client ID */
  azureClientId: string;
  /** Azure AD tenant ID */
  azureTenantId: string;
  /** API app registration scope (e.g. api://<api-client-id>/.default) */
  azureApiScope: string;
  /** Sandbox ManagementService base URL (proxied via /sandbox-api) */
  sandboxMgmtUrl: string;
  /** Scope for MSAL token acquisition targeting W365Lithium-Mgmt (all mgmt services) */
  mgmtScope: string;
  /** API path prefix — relative ("/sandbox-api") for proxy/CDN, absolute URL for direct CORS calls */
  sandboxApiPrefix: string;
  /** Application Insights connection string (empty = telemetry disabled) */
  appInsightsConnectionString: string;
}

function getConfig(): AppConfig {
  return {
    appName: import.meta.env.VITE_APP_NAME || 'Windows 365A',
    appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID || '',
    azureApiScope: import.meta.env.VITE_AZURE_API_SCOPE || '',
    sandboxMgmtUrl: import.meta.env.VITE_SANDBOX_MGMT_URL || '',
    mgmtScope: import.meta.env.VITE_MGMT_SCOPE || '',
    sandboxApiPrefix: import.meta.env.VITE_SANDBOX_API_PREFIX || '/sandbox-api',
    appInsightsConnectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING || '',
  };
}

/** Singleton configuration object. */
export const config = getConfig();
